import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {QuoteTypes} from "../../../../types/enums";
import {EstimateUpdateType, UpdateEstimateParams} from "../types/UpdateEstimateParams";
import {UpdateEstimateResult} from "../types/UpdateEstimateResult";


export const useUpdateEstimate = (
	params: UpdateEstimateParams,
	onSuccess: (result: UpdateEstimateResult) => void,
	onError: (error: string) => void) => {

	let method = '';
	let requestParams: any;
	switch (params.updateType) {
		case EstimateUpdateType.Info:
			method = 'update-info';
			requestParams = {
				quoteID: params.estimate.quoteID,
				salesAssocNbr: params.estimate.salesAssocNbr,
				salesAssocName: params.estimate.salesAssocName
			};
			break;

		case EstimateUpdateType.CustomerContact:
			method = 'submit-contact';
			requestParams = {
				quoteID: params.estimate.quoteID,
				customerContactDate: params.estimate.customerContactDate
			};
			break;

		case EstimateUpdateType.Schedule:
			method = 'submit-schedule';
			requestParams = {
				quoteID: params.estimate.quoteID,
				scheduledAppointmentDate: params.estimate.scheduledAppointmentDate
			};
			break;

		case EstimateUpdateType.CustomerInfo:
			method = 'update-customer-info';
			requestParams = {
				quoteID: params.estimate.quoteID,
				assignedCompanyID: params.estimate.assignedCompanyID,
				customerPhone: params.estimate.customerPhone,
				customerEmail: params.estimate.customerEmail,
			};
			break;
	}

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("estimate/" + method, requestParams) as UpdateEstimateResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError(`Error when updating the ${params.estimate.quoteTypeID === QuoteTypes.Lead ? "lead" : "estimate"}: ` +
					result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
